import React from 'react';

const CTAMinimal = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-black">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          {/* Headline */}
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-primary leading-tight">
            Ready to scale with{' '}
            <span className="font-serif-italic text-gold">
              AI-driven performance marketing?
            </span>
          </h2>

          {/* Subtext */}
          <p className="text-lg text-secondary font-sans leading-relaxed">
            Book a free growth audit — I'll analyse your current campaigns and show you exactly where AI tools can accelerate results
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <button
              onClick={scrollToContact}
              className="inline-flex items-center justify-center px-8 py-4 bg-gold text-black rounded-full font-sans font-medium hover:opacity-90 transition-opacity"
            >
              Get free growth audit
            </button>
            <a
              href="mailto:aryanshivhare004@gmail.com"
              className="inline-flex items-center justify-center px-8 py-4 text-gold font-sans font-medium underline underline-offset-4 hover:opacity-60 transition-opacity"
            >
              Email directly
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTAMinimal;
